import { render, staticRenderFns } from "./addAccountHistory.vue?vue&type=template&id=c5e53ac0&scoped=true"
import script from "./addAccountHistory.vue?vue&type=script&lang=js"
export * from "./addAccountHistory.vue?vue&type=script&lang=js"
import style0 from "./addAccountHistory.vue?vue&type=style&index=0&id=c5e53ac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e53ac0",
  null
  
)

export default component.exports